import React from 'react'
import "./Order.css"


function Order() {
  return (
    <div className='order'>
      
            <h2>Your booking has been confirmed</h2>
     

        </div>
 
  )
}

export default Order